export { default as InfoPanel} from './src/info-panel';
